import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import it from '../locales/vuetify/it'
import en from '../locales/vuetify/en'
import es from '../locales/vuetify/es'
import de from '../locales/vuetify/de'


Vue.use(Vuetify, {
  iconfont: 'mdi', // 'md' || 'mdi' || 'fa' || 'fa4'
  lang: {
    locales: { 'IT': it, 'EN': en, 'ES': es, "DE": de},
    //locales: {'IT': it},
    current: 'IT'
  },
  theme: {
    "primary": "#ffffff",
    "secondary": "#000000",
    "accent": "#2DB8E2",
    "error": "#B40000",
    "info": "#000000",
    "success": "#56C91A",
    "warning": "#EB8903",
    "blueprimary": "#002141",
    "coloricon": "#EB8903",
    "colorbackground": "#C6E0E8",
    "button-light": "#2DB8E2",
    "button-dark": "#0052A3",
    "menubackground": "#071626",
    "customerbar": "#083e5f",
    "bluetext": "#0052A3"


  },
  options: {
    customProperties: true
  }
})
